import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { UrlDetectorPipe } from '../../Services/urlDetector.pipe';
import { PopupComponent } from '../popup/popup.component';
import { BaseComponent } from '../../Pages/base.component';
import { SchoolApiService } from '../../Services/schoolApi.service';
import { ISchoolArticle } from '../../Models/schoolArticle.model';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule, UrlDetectorPipe],
  providers: [TranslateService, TranslatePipe],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.css',
})
export class CarouselComponent extends BaseComponent {
  @Input() items: ISchoolArticle[] = [];

  constructor(
    override readonly schoolApiService: SchoolApiService,
    private dialog: MatDialog
  ) {
    super(schoolApiService);
  }

  openArticle(article: ISchoolArticle): void {
    this.dialog.open(PopupComponent, {
      data: article,
      maxWidth: '90%',
      height: '80%',
      position: { top: '5%', left: '15%' },
    });
  }
}
